import ContextLayout from '../ContextLayout';
import { createLayout } from './createLayout';

const LayoutDefault = createLayout(['header', 'body', 'footer'], (props, { slots }) => {
  const { header, body, footer } = slots ?? {};

  return (
    <ContextLayout {...{ view: props.entry, ...props }}>
      {header}
      {body}
      {footer}
    </ContextLayout>
  );
});

export default LayoutDefault;
